import { Component, type ErrorInfo, type ReactNode } from 'react';
import { errorMessage } from '../safe';
import './components.css';

interface Props {
  /** Shown in the fallback, e.g. the dock title. */
  name: string;
  children: ReactNode;
  onError?(error: unknown, info: ErrorInfo): void;
}

interface State {
  error: unknown;
  failed: boolean;
}

/** Contains a crash to one panel or dialog and offers a retry. */
export class ErrorBoundary extends Component<Props, State> {
  override state: State = { error: null, failed: false };

  static getDerivedStateFromError(error: unknown): State {
    return { error, failed: true };
  }

  override componentDidCatch(error: unknown, info: ErrorInfo): void {
    this.props.onError?.(error, info);
  }

  override render(): ReactNode {
    if (!this.state.failed) return this.props.children;
    return (
      <div className="ui-boundary" role="alert">
        <strong>{this.props.name} stopped working</strong>
        <span className="ui-error-text ui-selectable">{errorMessage(this.state.error)}</span>
        <button type="button" className="ui-btn" onClick={() => this.setState({ error: null, failed: false })}>
          Reload panel
        </button>
      </div>
    );
  }
}
